import Layout from "../../components/mainPage/Layout";
import { Link } from "react-router-dom";
import IEC61850Server from "../../images/systemComponents/IEC61850Server.svg";
import { ZoomImageContainer } from "shared/components/Parameters";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 61850 (Сервер)
                </h1>
                <div className=" w-100 align-start  ">
                    <p >
                        <b>Сервер МЭК 61850 </b>  в SCADA NPT Expert используется для передачи данных по стандарту МЭК 61850-90-2. Передача данных по стандарту МЭК 61850-90-2 используется для обмена информацией между удалёнными объектами и централизованными системами управления.
                    </p>
                    <div style={{ float: 'right' }}>
                        <div style={{ maxWidth: '500px' }}>
                            <ZoomImageContainer
                                image={IEC61850Server}
                            />
                            {/* <img
                                style={{}}
                                src={IEC61850Server}
                                className="mb-4 w-100"
                                alt="IEC61850 Сервер"
                            /> */}
                        </div>
                    </div>
                    <div>
                        <p>Варианты применения МЭК 61850-90-2:</p>

                        <ul className="mb-4 description__list">

                            <li className="mb-1 description__number-li">Обмен данными между подстанциями
                                <ul>
                                    <li>Сервер МЭК 61850 SCADA системы на одной подстанции является источником данных для клиента МЭК 61850 SCADA системы на другой подстанции.</li>
                                    <li>Клиент МЭК 61850 SCADA системы на одной подстанции является приемником команд от сервера МЭК 61850 SCADA системы на другой подстанции. Например, для отключения ЛЭП с противоположного конца.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">Обмен данными со SCADA верхнего уровня
                                <ul>
                                    <li>Сервер МЭК 61850 SCADA системы на подстанции является источником оперативной информации для SCADA верхнего уровня (уровня РЭС/ ДЦ).</li>
                                    <li>Клиент МЭК 61850 SCADA системы на подстанции является приемником команд от SCADA верхнего уровня.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">Передача данных в аналитические системы
                                <ul>
                                    <li>
                                        Сервер МЭК 61850 SCADA системы на подстанции является источником данных для аналитических систем (например, на базе <Link className="text-links" to={`https://npt-platform.ru/`}>NPT Platform</Link>), которые могут принимать данные в том числе с использованием конвертера МЭК 61850 / CIM. Такой подход позволяет сформировать цифровую модель сети с использованием технологической информации, поступающей с уровня объекта.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
            </div>
        </div>
    </Layout >
}

export const meta = {
    title: 'МЭК 61850 (Сервер)',
    description: 'Сервер МЭК 61850  в SCADA NPT Expert используется для передачи данных по стандарту МЭК 61850-90-2. Передача данных по стандарту МЭК 61850-90-2 используется для обмена информацией между удалёнными объектами и централизованными системами управления.'
}